import { Injectable } from '@angular/core';
import { HttpService, VersionedData } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { PriceLevelDto } from '../dtos';

@Injectable()
export class PriceLevelsService {
  private path = 'versionedupdate/pricelevels';
  constructor(private httpService: HttpService) {}

  public getPriceLevels(versionHash: string): Observable<VersionedData<PriceLevelDto[]>> {
    return this.httpService.makeGet(`${this.path}/${versionHash}`);
  }
}
